// extracted by mini-css-extract-plugin
module.exports = {"title":"new-inline_title_YOxaJ"};